import {
  getCatalogKnmStatuses248SelectOptions,
  getCatalogPmStatusesSelectOptions,
} from 'CorePackage/CatalogsModule/selectors/catalogsSelectors';
import { getKnmErpStatusesSelectOptions } from 'KnmPackage/MainModule/selectors/knmSelectors';

import { PublishRulesRenderFunc } from '../types/PublishRulesRenderFunc';

export const renderKnmErknmStatus: PublishRulesRenderFunc = (item, state) => {
  const { newValue, oldValue } = item;

  const knmStatuses248SelectOptions = (state && getCatalogKnmStatuses248SelectOptions(state)) || [];
  const knmErpStatusesSelectOptions = (state && getKnmErpStatusesSelectOptions(state)) || [];
  const pmStatusesSelectOptions = (state && getCatalogPmStatusesSelectOptions(state)) || [];

  const allOptions = [...knmStatuses248SelectOptions, ...knmErpStatusesSelectOptions, ...pmStatusesSelectOptions];

  const renderedOldOption = allOptions.find(option => option.code === oldValue);
  const renderedNewOption = allOptions.find(option => option.code === newValue);

  return {
    renderedOldValue: renderedOldOption?.label || '',
    renderedNewValue: renderedNewOption?.label || '',
  };
};
